import { render, staticRenderFns } from "./FacebookCampaignListHeader.vue?vue&type=template&id=58dde75f"
import script from "./FacebookCampaignListHeader.vue?vue&type=script&lang=js"
export * from "./FacebookCampaignListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports